module.exports = __webpack_public_path__ + "img/top_bg1.4df7b769.jpg";